import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const TimelineContent = ({ data }) => {
    const timeline = Array.isArray(data?.timeline) ? data.timeline : [];
    const labels = timeline[0]?.values?.map(item => item.label) ?? [];

    const values = timeline.map(item => {
        const valuesByLabel = new Map(
            (Array.isArray(item.values) ? item.values : []).map(value => {
                const numericValue = Number(value.value);
                return [value.label, Number.isFinite(numericValue) ? numericValue : 0];
            })
        );

        return [
            item.label,
            ...labels.map(label => valuesByLabel.get(label) ?? 0)
        ];
    });

    useEffect(() => {
        GraphicUtils.lineChart('document-timeline', values, labels);
        if (values.length > 0) ReportUtils.createExportableTable(["Documento", ...labels], values, 'Documentos a vencer');
    }, [data]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Documentos a vencer</span>
                <div className="mt-3" id={'document-timeline'}></div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default TimelineContent;